import {
  ButtonVariant,
  HeadingLevel,
  IconPosition,
  MaterialColors,
  TextAlign,
} from "@/core/types/types";
import { TextVariant } from "@/core/components/Field/Text";
import { Box, Button, Divider, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { FieldValues, UseFormSetValue, useFormContext } from "react-hook-form";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";
import { voucherApi } from "@/api/voucherApi";

const VOUCHER_CODE: string = "voucherCode";

interface VoucherStatus {
  status: boolean;
}

const VoucherForm = () => {
  const [voucherCode, setVoucherCode] = useState<string | null>(null);
  const [isVoucherValid, setIsVoucherValid] = useState<boolean>(false);
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [isVoucherError, setIsVoucherError] = useState<boolean>(false);

  const {
    setValue,
  }: {
    formState: { errors: any };
    setValue: UseFormSetValue<FieldValues>;
  } = useFormContext();

  useEffect(() => {
    isVoucherValid && setValue(VOUCHER_CODE, voucherCode);
  }, [isVoucherValid]);

  const toggleVoucherCode = () => {
    if (isOpened) {
      setIsVoucherError(false);
    }

    setIsOpened(!isOpened);
  };

  const submitVoucherCode = async () => {
    if (voucherCode) {
      const { status }: VoucherStatus = await voucherApi.getVoucherStatus(
        voucherCode
      );
      if (status) {
        setIsVoucherValid(true);
        setIsVoucherError(false);
      } else {
        setIsVoucherValid(false);
        setIsVoucherError(true);
      }
    }
  };

  if (isVoucherValid) {
    return (
      <TextVariant
        text={t("voucher.confirmed")}
        iconName="celebration"
        iconPosition={IconPosition.IconBefore}
        variant={HeadingLevel.Body2}
      />
    );
  }

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Box sx={{ cursor: "pointer" }} onClick={toggleVoucherCode}>
        <TextVariant
          text={t("voucher.title")}
          color={MaterialColors.Primary}
          iconName={isOpened ? "RemoveCircle" : "AddCircle"}
          iconPosition={IconPosition.IconBefore}
          iconColor={MaterialColors.Primary}
          variant={HeadingLevel.Body2}
          textAlign={TextAlign.Center}
          isTextSelectable={false}
        />
      </Box>

      {isOpened && (
        <>
          <Box my={1}>
            <TextField
              id="outlined-basic"
              label={t("voucher.label")}
              placeholder={t("voucher.placeholder")}
              onChange={(event) => setVoucherCode(event.target.value)}
              error={isVoucherError}
            />
          </Box>

          {isVoucherError && (
            <TextVariant
              text={t("voucher.error")}
              variant={HeadingLevel.Body2}
              color={MaterialColors.Error}
            />
          )}

          <Button
            onClick={submitVoucherCode}
            variant={ButtonVariant.Contained}
            color={MaterialColors.Primary}
            sx={{ textTransform: "none" }}
            disabled={!voucherCode}
            className="navigation"
          >
            {t("voucher.button")}
          </Button>
        </>
      )}
    </Box>
  );
};

const VoucherCode = () => {
  return (
    <>
      <Divider />
      <Box my={2}>
        <VoucherForm />
      </Box>
      <Divider />
    </>
  );
};

export default VoucherCode;
